import NewMeetupForm from "../components/layout/meetups/NewMeetupForm";
import { useNavigate } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../index";

function NewMeetup() {
	const history = useNavigate();
	function addMeetupHandler(meetupData) {
		const dataUpload = async () => {
			const save_data = { ...meetupData, timestamp: serverTimestamp() };
			await addDoc(collection(db, "meetups"), save_data);
			history("/");
		};
		dataUpload();
		/*
        fetch(
            "https://react-meetup-4db79-default-rtdb.firebaseio.com/meetups.json",
            {
                method: "POST",
                body: JSON.stringify(meetupData),
                headers: {
                    "Content-Type": "application/json",
                },
            }
        ).then(() => {
            history("/");
        });*/
	}

	return (
		<section>
			<h1
				style={{
					fontFamily: "monospace",
					color: "#1E90FF",
					marginTop: "2rem",
					marginBottom: "2rem",
					fontWeight: "bold",
				}}
			>
				Add New Earthscape
			</h1>
			<NewMeetupForm onAddMeetup={addMeetupHandler} />
		</section>
	);
}

export default NewMeetup;
